import { useEffect } from 'react';
import * as logRocketService from '../../log-rocket/logRocketService';

const EVENT_NAME = 'app_event';

export const useLogRocketLinkedEvents = register => {
    useEffect(() => {
        const unregister = register(event => {
            logRocketService.trackEvent(EVENT_NAME, { id: event.id, type: event.event?.type });
            logRocketService.trackEvent(EVENT_NAME, {
                id: event.id,
                type: event.event?.type,
                componentId: event.event?.id,
            });
        });

        return unregister;
    }, [register]);
};
